import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-black py-16 px-4 border-t border-sand/10" data-id="element-69">
      <div className="max-w-5xl mx-auto text-center" data-id="element-70">
        <h3 className="font-display text-2xl font-bold text-cream mb-2" data-id="element-71">
          MegaPack Nutri Infantil Lista
        </h3>
        <p className="text-terracotta font-medium mb-6" data-id="element-72">
          El sistema práctico para nutricionistas que quieren intervenir mejor
          en consulta infantil.
        </p>

        <p className="text-cream/50 text-sm max-w-2xl mx-auto leading-relaxed mb-12" data-id="element-73">
          Porque trabajar consulta infantil no debería costarte tanta energía,
          tanta cabeza y tantas horas fuera del consultorio.
        </p>

        <div className="pt-8 border-t border-sand/10" data-id="element-74">
          <p className="text-xs text-cream/30 uppercase tracking-widest" data-id="element-75">
            © {currentYear} MegaPack Nutri Infantil Lista — Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}